var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagLatvia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.2598C24.8366 32.2598 32 25.0963 32 16.2598C32 7.42321 24.8366 0.259766 16 0.259766C7.16344 0.259766 0 7.42321 0 16.2598C0 25.0963 7.16344 32.2598 16 32.2598Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 0.259766C8.60716 0.259766 2.38678 5.27358 0.550781 12.0858H31.4485C29.6124 5.27358 23.392 0.259766 15.9996 0.259766Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 32.2597C23.392 32.2597 29.6124 27.2458 31.4484 20.4336H0.550781C2.38678 27.2458 8.60716 32.2597 15.9996 32.2597Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.259766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagLatvia);
export default __webpack_public_path__ + "static/media/flag_latvia.80a224681029028dcfaf556b88632ce5.svg";
export { ForwardRef as ReactComponent };